import script from "./LiquidCooling.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidCooling.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidCooling.vue?vue&type=style&index=0&id=4d7d2e72&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7d2e72"]])

export default __exports__